// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"799e9c2d","374":"ec4b8b37","382":"042c768a","441":"b18efbfb","500":"f11a8162","534":"86d6bca5","633":"7c8a1960","810":"2af958a2","966":"6dedd4a4","992":"44051f07"}[chunkId] + ".chunk.js";
};